export const bem = (name:string, classes:string[] = []) => {
    return classes.filter(item => !!item).map(className => `${name}--${className}`);
}